import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { getThumbnailImage } from "../../../utils/Helperfunctions";
import { Fragment } from "react";
import AddProjectCard from "./AddProjectCard";
import {
  isViewableFile,
  renderDifferentFilesThumbnail,
} from "../Common/Common/FileRenderMessage";

const RenderProjects = (props) => {
  const { projects, publicView, isFromAllProjects } = props;
  useEffect(()=>{
    // console.log(props.history.location.pathname.split('/'))
    const arraypathname=props.history.location.pathname.split('/')
    if(arraypathname.length>=4)
    {
      props.LoadProjectData(arraypathname[3]);
      props.OpenPopup("ViewModal");
    }
  },[])

  const handleDeleteProject = (projectId, isFromAllProjects) => {
    const isConfirm = window.confirm("Do you want to delete the project?");
    if (!isConfirm) return;
    props.DeleteCreatorProject(projectId, isFromAllProjects);
  };

  const editProject = (projectId) => {
    const { history } = props;
    props.closePopup();
    props.editUserProject(projectId, history);
  };

  const requestReview = (projectId) => {
    props.onFieldChange({
      name: "REVIEW_PROJECT_ID",
      value: projectId,
    });
  };

  // let uploadProjectThumbnail = null;
  // if (publicView !== true){
  //   uploadProjectThumbnail = (
  //     <AddProjectCard />
  //   )
  // }
  // console.log(projects)
  return (
    <>
      {projects.map((u, k) => {
        // {
        //   /* let imageIndex = u?.project_data?.images_or_links && u?.project_data?.images_or_links.findIndex((item) => item.value !== ""); */
        // }
        // {
        //   /* let image_url = u?.project_data?.images_or_links && u?.project_data.images_or_links.some((el) => el.isThumbnail === 1) ? u.project_data.images_or_links.filter((item) => item.isThumbnail === 1).map((filteredImg) => filteredImg.value)
        //                             :u?.project_data?.images_or_links && u?.project_data?.images_or_links?.[imageIndex]?.value; */
        // }
        const imageObj = u.project_data.images_or_links.find(
          (image) => image.isThumbnail === 1
        );
        const imageObject = imageObj
          ? imageObj
          : u.project_data.images_or_links[0];
        return u?.project_data?.status === 0 && publicView === true ? null : (
          <Fragment key={k}>
            <li
              className={`team shot-thumbnail cursor-pointer ${
                u?.project_data?.status === 0 ? "disabled" : ""
              }`}
              onClick={(e) => {
                props.ResetProjectError(false);
                if(props.match.path.includes(`/creator`)){
                  const username = props.location.pathname.split('/')[2]
                  props.history.push(`/creator/${username}/${u.project_data._id}/${u.project_data.title}`)
                }
                props.LoadProjectData(u.project_data._id);
                props.OpenPopup("ViewModal");
              }}
            >
              <div className="multi-shot">
                <div className="content-shot">
                  <div className="content-img">
                    <a href="/" onClick={e=>e.preventDefault()}
                      className="content-link"
                      // data-lightbox="mygallery"
                      // data-title="Dribbble"
                    >
                      {/* <picture> */}
                      {/* <img
                                    alt="Vicente Font Family"
                                    src={
                                        u?.project_data?.images_or_links &&
                                        u?.project_data.images_or_links.some(
                                        (el) => el.isThumbnail === 1
                                        )
                                        ? u.project_data.images_or_links
                                            .filter((item) => item.isThumbnail === 1)
                                            .map((filteredImg) => filteredImg.value)
                                        : u?.project_data?.images_or_links &&
                                            u?.project_data?.images_or_links[0]?.value
                                    }
                                    /> */}
                      {/* <div className="project-view"
                                    test = {image_url}
                                    style={{backgroundImage:`url(${getThumbnailImage(image_url, true)})`}}
                                    ></div> */}
                      <RenderImage
                        key={imageObject.value + Math.random().toFixed(4)}
                        image={imageObject}
                      />
                      {/* </picture> */}
                    </a>
                    {u?.project_data?.status === 0 ? (
                      <span className="under_review">
                        Project under review...
                      </span>
                    ) : null}
                    {publicView === true ? (
                      <></>
                    ) : (
                      <div className="dropdown_btn content-over portfolio">
                        <span
                          className="dropdown-toggle"
                          d="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                          onClick={(e) => {
                            e.stopPropagation();
                          }}
                        >
                          <i className="fas fa-ellipsis-h dropdown_icon"></i>
                        </span>
                        <div
                          className="dropdown-menu dropdown-list-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a href="/"
                            className="dropdown-item font-weight-600"
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              editProject(u.project_data._id);
                            }}

                            // data-toggle="modal"
                            // data-target="#editWorkSection"
                          >
                            Edit
                          </a>
                          <a href="/"
                            className={`dropdown-item font-weight-600 ${
                              u.review_status === 3
                                ? ""
                                : "post_a_project_tabs disabled"
                            }`}
                            //href="/#"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              requestReview(u.project_data._id);
                              props.OpenPopup("ReviewModal");
                            }}
                            data-toggle="modal"
                            data-target="#RequestReviewModal"
                          >
                            {u.review_status === 3
                              ? "Request Testimonial"
                              : u.review_status === 0
                              ? "Review Pending"
                              : "Reviewed"}
                          </a>
                          <a href="/"
                            className="dropdown-item font-weight-600 text-danger"
                            onClick={(e) => {
                              // props.DeleteCreatorProject(u.project_data._id, isFromAllProjects)
                              e.preventDefault();
                              handleDeleteProject(
                                u.project_data._id,
                                isFromAllProjects
                              );
                              e.stopPropagation();
                            }}
                          >
                            Delete
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <p style={{wordBreak:'break-word'}} className="d-line w-100 font-16 mob-font-14 font-weight-600 py-2 pl-2 mb-0 text-capitalize">
                {u?.project_data?.title}
              </p>
            </li>
          </Fragment>
        );
      })}
      {/* {publicView !== true ? <AddProjectCard /> : null} */}
    </>
  );
};

const mapDispatch = (dispatchEvent) => ({
  DeleteCreatorProject: (id, isFromAllProjects) =>
    dispatchEvent({
      type: "DELETE_CREATOR_PROJECT",
      payload: { id, isFromAllProjects },
    }),
    ResetProjectError:(data)=>dispatchEvent({type:"PROJECT_DATA_ERROR",values:data}),
  editUserProject: (id, history) =>
    dispatchEvent({ type: "EDIT_PROJECT", payload: { id, history } }),
  onFieldChange: (e) =>
    dispatchEvent({
      type: "ON_FIELDCHANGE_SAGA",
      payload: { name: e.name, value: e.value },
    }),
  OpenPopup: (text) =>
    dispatchEvent({ type: "OPEN_POPUP_SAGA", payload: { Component: text } }),
  closePopup: () => dispatchEvent({ type: "CLOSE_POPUP_SAGA", payload: {} }),
  LoadProjectData: (id) =>
    dispatchEvent({ type: "LOAD_PROJECT_DATA", payload: { id } }),
    
});

export default withRouter(connect(null, mapDispatch)(RenderProjects));

const RenderImage = ({ image }) => {
  const {type}=image;
  const {value}=image;
  const [thumbnail, setThumbnail] = useState(null);
  useEffect(() => {
    const getThumbnailImageFunc = async (u) => {
      const url = await getThumbnailImage(u);
      setThumbnail(url);
    };
    if (type === "url") {
      getThumbnailImageFunc(value);
    } else {
      setThumbnail(value);
    }
  }, [type,value]);

  return (
    <div
      className="project-view"
      style={{
        backgroundImage: `url("${
          isViewableFile(image.value)
            ? renderDifferentFilesThumbnail(image.value)
            : thumbnail
        }")`,
      }}
    ></div>
  );
};
